import { MessageSquare } from "lucide-react";

export function MessagesScreen() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted">
        <MessageSquare className="h-6 w-6 text-muted-foreground" />
      </div>
      <div>
        <p className="text-sm font-semibold text-foreground">Messages</p>
        <p className="mt-1 text-xs text-muted-foreground">
          SMS and WhatsApp conversations will appear here.
        </p>
      </div>
    </div>
  );
}
